import React from "react";
import styled from "@emotion/styled";
import { colors } from "src/theme";

const CardStyle = styled.div((props: { padding?: string | number, radius?: string | number, background?: string }) => ({
  padding: props.padding || '16px 12px',
  borderRadius: props.radius || '16px',
  backgroundColor: props.background || colors.background7,
  width: '100%',
}));

interface CardProps {
  title?: React.JSX.Element;
  children: React.ReactNode;
  padding?: string | number;
  radius?: string | number;
  background?: string;
  style?: React.CSSProperties;
  className?: string;
}

export const Card = ({ title, children, padding, radius, background, className, style }: CardProps) => (
  <CardStyle padding={padding} radius={radius} background={background} style={style} className={className}>
    {title}
    {children}
  </CardStyle>
);